import { Component, OnInit } from '@angular/core';
import { AgentLoginService } from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { ModulesBasedApiSuffix, formConfigs, prepareRequiredHttpParams } from '@app/shared/utils';
import { SalesModuleApiSuffixModels } from '@modules/sales/shared';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
@Component({
  selector: 'app-customer-call-component',
  templateUrl: './customer-call.component.html',
  styleUrls: ['./lead-notes.scss'],
})
export class CustomerCallModalComponent implements OnInit {
  leadId: string;
  formConfigs = formConfigs;
  dialedNumbers = undefined;
  premisesNumber;
  mobileNumber1;
  mobileNumber2;
  officeNumber;

  constructor(private agentLoginService: AgentLoginService, private rxjsService: RxjsService, public dialogService: DialogService,
    public ref: DynamicDialogRef, public config: DynamicDialogConfig, private crudService: CrudService) {
  }

  ngOnInit() {
    this.rxjsService.setDialogOpenProperty(true);
    if (!this.agentLoginService.canInitiateOutboundCall) {
      this.agentLoginService.openOpenscapeLoginPopup();
      this.ref.close(false);
    }
    this.crudService.get(ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.SALES_API_CONTACT_NUMBER, undefined, false,
      prepareRequiredHttpParams({
        leadId: this.config?.data?.leadId
      })).subscribe(resp => {
        this.dialedNumbers = resp.resources;
        if (resp.isSuccess && resp.statusCode == 200 && resp.resources) {
          this.premisesNumber = resp.resources.premisesNumber;
          this.mobileNumber1 = resp.resources.mobileNumber1;
          this.mobileNumber2 = resp.resources.mobileNumber2;
          this.officeNumber = resp.resources.officeNumber;
          this.rxjsService.setDialogOpenProperty(false);
        }
      });
  }

  dialogClose() {
    this.ref.close(false);
  }

  callDial(e): void {
    this.dialogClose();
    let data = {
      customerContactNumber: e,
      leadId: this.config?.data?.leadId,
      clientName: this.dialedNumbers.customerName
    }
    this.agentLoginService.initiateOutboundCall(data);
  }
}
